import { dataBuildingSolid } from 'dls-icons-data'
import { createIcon } from '../common'

const IconBuildingSolid = /*#__PURE__*/createIcon(dataBuildingSolid)
export default IconBuildingSolid
